import { adminSlice } from '@sonar-software/sonar-admin';
import { applicationReducers } from './application';
import { combineReducers } from 'redux';
import { coreSlice } from '@sonar-software/sonar-core';
import { importsSlice } from '@sonar-software/sonar-imports';
import { integrationsSlice } from '@sonar-software/sonar-integrations';
import { issuesSlice } from '@sonar-software/sonar-issues';
import { notificationsSlice } from '@sonar-software/sonar-notifications';
import { securitySlice } from '@sonar-software/sonar-security';

export const reducers = combineReducers({
	admin: adminSlice.adminReducers,
	application: applicationReducers,
	core: coreSlice.coreReducers,
	imports: importsSlice.importsReducers,
	integrations: integrationsSlice.integrationReducers,
	issues: issuesSlice.issuesReducers,
	notifications: notificationsSlice.notificationsReducers,
	security: securitySlice.securityReducers
});
